import * as e from "react";
import { c as oe, w as ie, r as ue, m as le, a as K } from "./room-Q0GUQkyk.mjs";
import { C as G, S as de, a as me, M as _, b as fe, T as N, c as he, d as pe, D as J, e as ge, f as z, L as H, G as ve, P as q, F as Ee, g as Se, h as ke, R as be, i as Ce, j as we, k as ye, B as De } from "./components-DqcPwJ_9.mjs";
import { w as Ie, x as B, y as Te, z as Me, A as Q, t as X, B as Pe, C as Ne } from "./hooks-CA4A5LBF.mjs";
import { j as Y, as as Ae, at as Le, l as T, a as Re, au as Ve, av as Oe, a1 as F, aw as xe, ax as $e } from "./contexts-DzwYztG5.mjs";
import { Track as E, facingModeFromLocalTrack as Ue, Mutex as _e, createLocalTracks as Fe, createLocalVideoTrack as Be, VideoPresets as We, createLocalAudioTrack as je, RoomEvent as qe } from "livekit-client";
function Z({
  messageFormatter: n,
  messageDecoder: o,
  messageEncoder: i,
  channelTopic: u,
  ...g
}) {
  const h = e.useRef(null), l = e.useRef(null), d = e.useMemo(() => ({ messageDecoder: o, messageEncoder: i, channelTopic: u }), [o, i, u]), { chatMessages: c, send: C, isSending: t } = Ie(d), f = Y(), s = e.useRef(0);
  async function v(a) {
    a.preventDefault(), l.current && l.current.value.trim() !== "" && (await C(l.current.value), l.current.value = "", l.current.focus());
  }
  return e.useEffect(() => {
    h && h.current?.scrollTo({ top: h.current.scrollHeight });
  }, [h, c]), e.useEffect(() => {
    if (!f || c.length === 0)
      return;
    if (f.widget.state?.showChat && c.length > 0 && s.current !== c[c.length - 1]?.timestamp) {
      s.current = c[c.length - 1]?.timestamp;
      return;
    }
    const a = c.filter(
      (p) => !s.current || p.timestamp > s.current
    ).length, { widget: m } = f;
    a > 0 && m.state?.unreadMessages !== a && m.dispatch?.({ msg: "unread_msg", count: a });
  }, [c, f?.widget]), /* @__PURE__ */ e.createElement("div", { ...g, className: "lk-chat" }, /* @__PURE__ */ e.createElement("div", { className: "lk-chat-header" }, "Messages", f && /* @__PURE__ */ e.createElement(G, { className: "lk-close-button" }, /* @__PURE__ */ e.createElement(de, null))), /* @__PURE__ */ e.createElement("ul", { className: "lk-list lk-chat-messages", ref: h }, g.children ? c.map(
    (a, m) => oe(g.children, {
      entry: a,
      key: a.id ?? m,
      messageFormatter: n
    })
  ) : c.map((a, m, p) => {
    const k = m >= 1 && p[m - 1].from === a.from, r = m >= 1 && a.timestamp - p[m - 1].timestamp < 6e4;
    return /* @__PURE__ */ e.createElement(
      me,
      {
        key: a.id ?? m,
        hideName: k,
        hideTimestamp: k === !1 ? !1 : r,
        entry: a,
        messageFormatter: n
      }
    );
  })), /* @__PURE__ */ e.createElement("form", { className: "lk-chat-form", onSubmit: v }, /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "lk-form-control lk-chat-form-input",
      disabled: t,
      ref: l,
      type: "text",
      placeholder: "Enter a message...",
      onInput: (a) => a.stopPropagation(),
      onKeyDown: (a) => a.stopPropagation(),
      onKeyUp: (a) => a.stopPropagation()
    }
  ), /* @__PURE__ */ e.createElement("button", { type: "submit", className: "lk-button lk-chat-form-button", disabled: t }, "Send")));
}
function L({
  kind: n,
  initialSelection: o,
  onActiveDeviceChange: i,
  tracks: u,
  requestPermissions: g = !1,
  ...h
}) {
  const [l, d] = e.useState(!1), [c, C] = e.useState([]), [t, f] = e.useState(!0), [s, v] = e.useState(g), a = (r, D) => {
    T.debug("handle device change"), d(!1), i?.(r, D);
  }, m = e.useRef(null), p = e.useRef(null);
  e.useLayoutEffect(() => {
    l && v(!0);
  }, [l]), e.useLayoutEffect(() => {
    let r;
    return m.current && p.current && (c || t) && (r = Ae(m.current, p.current, (D, w) => {
      p.current && Object.assign(p.current.style, { left: `${D}px`, top: `${w}px` });
    })), f(!1), () => {
      r?.();
    };
  }, [m, p, c, t]);
  const k = e.useCallback(
    (r) => {
      p.current && r.target !== m.current && l && Le(p.current, r) && d(!1);
    },
    [l, p, m]
  );
  return e.useEffect(() => (document.addEventListener("click", k), () => {
    document.removeEventListener("click", k);
  }), [k]), /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "button",
    {
      className: "lk-button lk-button-menu",
      "aria-pressed": l,
      ...h,
      onClick: () => d(!l),
      ref: m
    },
    h.children
  ), !h.disabled && /* @__PURE__ */ e.createElement(
    "div",
    {
      className: "lk-device-menu",
      ref: p,
      style: { visibility: l ? "visible" : "hidden" }
    },
    n ? /* @__PURE__ */ e.createElement(
      _,
      {
        initialSelection: o,
        onActiveDeviceChange: (r) => a(n, r),
        onDeviceListChange: C,
        kind: n,
        track: u?.[n],
        requestPermissions: s
      }
    ) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: "lk-device-menu-heading" }, "Audio inputs"), /* @__PURE__ */ e.createElement(
      _,
      {
        kind: "audioinput",
        onActiveDeviceChange: (r) => a("audioinput", r),
        onDeviceListChange: C,
        track: u?.audioinput,
        requestPermissions: s
      }
    ), /* @__PURE__ */ e.createElement("div", { className: "lk-device-menu-heading" }, "Video inputs"), /* @__PURE__ */ e.createElement(
      _,
      {
        kind: "videoinput",
        onActiveDeviceChange: (r) => a("videoinput", r),
        onDeviceListChange: C,
        track: u?.videoinput,
        requestPermissions: s
      }
    ))
  ));
}
function W() {
  e.useEffect(() => {
    ie();
  }, []);
}
function Ke(n, o) {
  const [i, u] = e.useState(), g = e.useMemo(() => new _e(), []);
  return e.useEffect(() => {
    let h = !1, l = [];
    return g.lock().then(async (d) => {
      try {
        (n.audio || n.video) && (l = await Fe(n), h ? l.forEach((c) => c.stop()) : u(l));
      } catch (c) {
        o && c instanceof Error ? o(c) : T.error(c);
      } finally {
        d();
      }
    }), () => {
      h = !0, l.forEach((d) => {
        d.stop();
      });
    };
  }, [JSON.stringify(n, ue), o, g]), i;
}
function et(n, o, i) {
  const [u, g] = e.useState(null), [h, l] = e.useState(!1), d = Te({ kind: i }), [c, C] = e.useState(
    void 0
  ), [t, f] = e.useState(), [s, v] = e.useState(o);
  e.useEffect(() => {
    v(o);
  }, [o]);
  const a = async (k, r) => {
    try {
      const D = r === "videoinput" ? await Be({
        deviceId: k,
        resolution: We.h720.resolution
      }) : await je({ deviceId: k }), w = await D.getDeviceId(!1);
      w && k !== w && (p.current = w, v(w)), f(D);
    } catch (D) {
      D instanceof Error && g(D);
    }
  }, m = async (k, r) => {
    await k.setDeviceId(r), p.current = r;
  }, p = e.useRef(s);
  return e.useEffect(() => {
    n && !t && !u && !h && (T.debug("creating track", i), l(!0), a(s, i).finally(() => {
      l(!1);
    }));
  }, [n, t, u, h]), e.useEffect(() => {
    t && (n ? c?.deviceId && p.current !== c?.deviceId ? (T.debug(`switching ${i} device from`, p.current, c.deviceId), m(t, c.deviceId)) : (T.debug(`unmuting local ${i} track`), t.unmute()) : (T.debug(`muting ${i} track`), t.mute().then(() => T.debug(t.mediaStreamTrack))));
  }, [t, c, n, i]), e.useEffect(() => () => {
    t && (T.debug(`stopping local ${i} track`), t.stop(), t.mute());
  }, []), e.useEffect(() => {
    C(d?.find((k) => k.deviceId === s));
  }, [s, d]), {
    selectedDevice: c,
    localTrack: t,
    deviceError: u
  };
}
function tt({
  defaults: n = {},
  onValidate: o,
  onSubmit: i,
  onError: u,
  debug: g,
  joinLabel: h = "Join Room",
  micLabel: l = "Microphone",
  camLabel: d = "Camera",
  userLabel: c = "Username",
  persistUserChoices: C = !0,
  videoProcessor: t,
  ...f
}) {
  const {
    userChoices: s,
    saveAudioInputDeviceId: v,
    saveAudioInputEnabled: a,
    saveVideoInputDeviceId: m,
    saveVideoInputEnabled: p,
    saveUsername: k
  } = B({
    defaults: n,
    preventSave: !C,
    preventLoad: !C
  }), [r, D] = e.useState(s), [w, V] = e.useState(r.audioEnabled), [M, O] = e.useState(r.videoEnabled), [P, b] = e.useState(r.audioDeviceId), [y, te] = e.useState(r.videoDeviceId), [A, ae] = e.useState(r.username);
  e.useEffect(() => {
    a(w);
  }, [w, a]), e.useEffect(() => {
    p(M);
  }, [M, p]), e.useEffect(() => {
    v(P);
  }, [P, v]), e.useEffect(() => {
    m(y);
  }, [y, m]), e.useEffect(() => {
    k(A);
  }, [A, k]);
  const R = Ke(
    {
      audio: w ? { deviceId: s.audioDeviceId } : !1,
      video: M ? { deviceId: s.videoDeviceId, processor: t } : !1
    },
    u
  ), x = e.useRef(null), I = e.useMemo(
    () => R?.filter((S) => S.kind === E.Kind.Video)[0],
    [R]
  ), ne = e.useMemo(() => {
    if (I) {
      const { facingMode: S } = Ue(I);
      return S;
    } else
      return "undefined";
  }, [I]), j = e.useMemo(
    () => R?.filter((S) => S.kind === E.Kind.Audio)[0],
    [R]
  );
  e.useEffect(() => (x.current && I && (I.unmute(), I.attach(x.current)), () => {
    I?.detach();
  }), [I]);
  const [ce, se] = e.useState(), $ = e.useCallback(
    (S) => typeof o == "function" ? o(S) : S.username !== "",
    [o]
  );
  e.useEffect(() => {
    const S = {
      username: A,
      videoEnabled: M,
      videoDeviceId: y,
      audioEnabled: w,
      audioDeviceId: P
    };
    D(S), se($(S));
  }, [A, M, $, w, P, y]);
  function re(S) {
    S.preventDefault(), $(r) ? typeof i == "function" && i(r) : T.warn("Validation failed with: ", r);
  }
  return W(), /* @__PURE__ */ e.createElement("div", { className: "lk-prejoin", ...f }, /* @__PURE__ */ e.createElement("div", { className: "lk-video-container" }, I && /* @__PURE__ */ e.createElement("video", { ref: x, width: "1280", height: "720", "data-lk-facing-mode": ne }), (!I || !M) && /* @__PURE__ */ e.createElement("div", { className: "lk-camera-off-note" }, /* @__PURE__ */ e.createElement(fe, null))), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-container" }, /* @__PURE__ */ e.createElement("div", { className: "lk-button-group audio" }, /* @__PURE__ */ e.createElement(
    N,
    {
      initialState: w,
      source: E.Source.Microphone,
      onChange: (S) => V(S)
    },
    l
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    L,
    {
      initialSelection: P,
      kind: "audioinput",
      disabled: !j,
      tracks: { audioinput: j },
      onActiveDeviceChange: (S, U) => b(U)
    }
  ))), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group video" }, /* @__PURE__ */ e.createElement(
    N,
    {
      initialState: M,
      source: E.Source.Camera,
      onChange: (S) => O(S)
    },
    d
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    L,
    {
      initialSelection: y,
      kind: "videoinput",
      disabled: !I,
      tracks: { videoinput: I },
      onActiveDeviceChange: (S, U) => te(U)
    }
  )))), /* @__PURE__ */ e.createElement("form", { className: "lk-username-container" }, /* @__PURE__ */ e.createElement(
    "input",
    {
      className: "lk-form-control",
      id: "username",
      name: "username",
      type: "text",
      defaultValue: A,
      placeholder: c,
      onChange: (S) => ae(S.target.value),
      autoComplete: "off"
    }
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      className: "lk-button lk-join-button",
      type: "submit",
      onClick: re,
      disabled: !ce
    },
    h
  )), g && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("strong", null, "User Choices:"), /* @__PURE__ */ e.createElement("ul", { className: "lk-list", style: { overflow: "hidden", maxWidth: "15rem" } }, /* @__PURE__ */ e.createElement("li", null, "Username: ", `${r.username}`), /* @__PURE__ */ e.createElement("li", null, "Video Enabled: ", `${r.videoEnabled}`), /* @__PURE__ */ e.createElement("li", null, "Audio Enabled: ", `${r.audioEnabled}`), /* @__PURE__ */ e.createElement("li", null, "Video Device: ", `${r.videoDeviceId}`), /* @__PURE__ */ e.createElement("li", null, "Audio Device: ", `${r.audioDeviceId}`))));
}
function Ge({ props: n }) {
  const { dispatch: o, state: i } = Re().widget, u = "lk-button lk-settings-toggle";
  return { mergedProps: e.useMemo(() => le(n, {
    className: u,
    onClick: () => {
      o && o({ msg: "toggle_settings" });
    },
    "aria-pressed": i?.showSettings ? "true" : "false"
  }), [n, u, o, i]) };
}
const Je = /* @__PURE__ */ e.forwardRef(
  function(o, i) {
    const { mergedProps: u } = Ge({ props: o });
    return /* @__PURE__ */ e.createElement("button", { ref: i, ...u }, o.children);
  }
), ze = (n) => {
  switch (n) {
    case E.Source.Camera:
      return 1;
    case E.Source.Microphone:
      return 2;
    case E.Source.ScreenShare:
      return 3;
    default:
      return 0;
  }
};
function ee({
  variation: n,
  controls: o,
  saveUserChoices: i = !0,
  onDeviceError: u,
  ...g
}) {
  const [h, l] = e.useState(!1), d = Y();
  e.useEffect(() => {
    d?.widget.state?.showChat !== void 0 && l(d?.widget.state?.showChat);
  }, [d?.widget.state?.showChat]);
  const C = Me(`(max-width: ${h ? 1e3 : 760}px)`) ? "minimal" : "verbose";
  n ?? (n = C);
  const t = { leave: !0, ...o }, f = Q();
  if (!f)
    t.camera = !1, t.chat = !1, t.microphone = !1, t.screenShare = !1;
  else {
    const b = (y) => f.canPublish && (f.canPublishSources.length === 0 || f.canPublishSources.includes(ze(y)));
    t.camera ?? (t.camera = b(E.Source.Camera)), t.microphone ?? (t.microphone = b(E.Source.Microphone)), t.screenShare ?? (t.screenShare = b(E.Source.ScreenShare)), t.chat ?? (t.chat = f.canPublishData && o?.chat);
  }
  const s = e.useMemo(
    () => n === "minimal" || n === "verbose",
    [n]
  ), v = e.useMemo(
    () => n === "textOnly" || n === "verbose",
    [n]
  ), a = Ve(), [m, p] = e.useState(!1), k = e.useCallback(
    (b) => {
      p(b);
    },
    [p]
  ), r = K({ className: "lk-control-bar" }, g), {
    saveAudioInputEnabled: D,
    saveVideoInputEnabled: w,
    saveAudioInputDeviceId: V,
    saveVideoInputDeviceId: M
  } = B({ preventSave: !i }), O = e.useCallback(
    (b, y) => y ? D(b) : null,
    [D]
  ), P = e.useCallback(
    (b, y) => y ? w(b) : null,
    [w]
  );
  return /* @__PURE__ */ e.createElement("div", { ...r }, t.microphone && /* @__PURE__ */ e.createElement("div", { className: "lk-button-group" }, /* @__PURE__ */ e.createElement(
    N,
    {
      source: E.Source.Microphone,
      showIcon: s,
      onChange: O,
      onDeviceError: (b) => u?.({ source: E.Source.Microphone, error: b })
    },
    v && "Microphone"
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    L,
    {
      kind: "audioinput",
      onActiveDeviceChange: (b, y) => V(y ?? "default")
    }
  ))), t.camera && /* @__PURE__ */ e.createElement("div", { className: "lk-button-group" }, /* @__PURE__ */ e.createElement(
    N,
    {
      source: E.Source.Camera,
      showIcon: s,
      onChange: P,
      onDeviceError: (b) => u?.({ source: E.Source.Camera, error: b })
    },
    v && "Camera"
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    L,
    {
      kind: "videoinput",
      onActiveDeviceChange: (b, y) => M(y ?? "default")
    }
  ))), t.screenShare && a && /* @__PURE__ */ e.createElement(
    N,
    {
      source: E.Source.ScreenShare,
      captureOptions: { audio: !0, selfBrowserSurface: "include" },
      showIcon: s,
      onChange: k,
      onDeviceError: (b) => u?.({ source: E.Source.ScreenShare, error: b })
    },
    v && (m ? "Stop screen share" : "Share screen")
  ), t.chat && /* @__PURE__ */ e.createElement(G, null, s && /* @__PURE__ */ e.createElement(he, null), v && "Chat"), t.settings && /* @__PURE__ */ e.createElement(Je, null, s && /* @__PURE__ */ e.createElement(pe, null), v && "Settings"), t.leave && /* @__PURE__ */ e.createElement(J, null, s && /* @__PURE__ */ e.createElement(ge, null), v && "Leave"), /* @__PURE__ */ e.createElement(z, null));
}
function at({
  chatMessageFormatter: n,
  chatMessageDecoder: o,
  chatMessageEncoder: i,
  SettingsComponent: u,
  ...g
}) {
  const [h, l] = e.useState({
    showChat: !1,
    unreadMessages: 0,
    showSettings: !1
  }), d = e.useRef(null), c = X(
    [
      { source: E.Source.Camera, withPlaceholder: !0 },
      { source: E.Source.ScreenShare, withPlaceholder: !1 }
    ],
    { updateOnlyOn: [qe.ActiveSpeakersChanged], onlySubscribed: !1 }
  ), C = (a) => {
    T.debug("updating widget state", a), l(a);
  }, t = Oe(), f = c.filter(F).filter((a) => a.publication.source === E.Source.ScreenShare), s = Pe(t)?.[0], v = c.filter((a) => !xe(a, s));
  return e.useEffect(() => {
    if (f.some((a) => a.publication.isSubscribed) && d.current === null ? (T.debug("Auto set screen share focus:", { newScreenShareTrack: f[0] }), t.pin.dispatch?.({ msg: "set_pin", trackReference: f[0] }), d.current = f[0]) : d.current && !f.some(
      (a) => a.publication.trackSid === d.current?.publication?.trackSid
    ) && (T.debug("Auto clearing screen share focus."), t.pin.dispatch?.({ msg: "clear_pin" }), d.current = null), s && !F(s)) {
      const a = c.find(
        (m) => m.participant.identity === s.participant.identity && m.source === s.source
      );
      a !== s && F(a) && t.pin.dispatch?.({ msg: "set_pin", trackReference: a });
    }
  }, [
    f.map((a) => `${a.publication.trackSid}_${a.publication.isSubscribed}`).join(),
    s?.publication?.trackSid,
    c
  ]), W(), /* @__PURE__ */ e.createElement("div", { className: "lk-video-conference", ...g }, $e() && /* @__PURE__ */ e.createElement(
    H,
    {
      value: t,
      onWidgetChange: C
    },
    /* @__PURE__ */ e.createElement("div", { className: "lk-video-conference-inner" }, s ? /* @__PURE__ */ e.createElement("div", { className: "lk-focus-layout-wrapper" }, /* @__PURE__ */ e.createElement(Ee, null, /* @__PURE__ */ e.createElement(Se, { tracks: v }, /* @__PURE__ */ e.createElement(q, null)), s && /* @__PURE__ */ e.createElement(ke, { trackRef: s }))) : /* @__PURE__ */ e.createElement("div", { className: "lk-grid-layout-wrapper" }, /* @__PURE__ */ e.createElement(ve, { tracks: c }, /* @__PURE__ */ e.createElement(q, null))), /* @__PURE__ */ e.createElement(ee, { controls: { chat: !0, settings: !!u } })),
    /* @__PURE__ */ e.createElement(
      Z,
      {
        style: { display: h.showChat ? "grid" : "none" },
        messageFormatter: n,
        messageEncoder: i,
        messageDecoder: o
      }
    ),
    u && /* @__PURE__ */ e.createElement(
      "div",
      {
        className: "lk-settings-menu-modal",
        style: { display: h.showSettings ? "block" : "none" }
      },
      /* @__PURE__ */ e.createElement(u, null)
    )
  ), /* @__PURE__ */ e.createElement(be, null), /* @__PURE__ */ e.createElement(Ce, null));
}
function nt({ ...n }) {
  const [o, i] = e.useState({
    showChat: !1,
    unreadMessages: 0
  }), u = X([E.Source.Microphone]);
  return W(), /* @__PURE__ */ e.createElement(H, { onWidgetChange: i }, /* @__PURE__ */ e.createElement("div", { className: "lk-audio-conference", ...n }, /* @__PURE__ */ e.createElement("div", { className: "lk-audio-conference-stage" }, /* @__PURE__ */ e.createElement(we, { tracks: u }, /* @__PURE__ */ e.createElement(ye, null))), /* @__PURE__ */ e.createElement(
    ee,
    {
      controls: { microphone: !0, screenShare: !1, camera: !1, chat: !0 }
    }
  ), o.showChat && /* @__PURE__ */ e.createElement(Z, null)));
}
function ct({
  controls: n,
  saveUserChoices: o = !0,
  onDeviceError: i,
  ...u
}) {
  const g = { leave: !0, microphone: !0, ...n }, h = Q(), { microphoneTrack: l, localParticipant: d } = Ne(), c = e.useMemo(() => ({
    participant: d,
    source: E.Source.Microphone,
    publication: l
  }), [d, l]);
  h ? g.microphone ?? (g.microphone = h.canPublish) : g.microphone = !1;
  const C = K({ className: "lk-agent-control-bar" }, u), { saveAudioInputEnabled: t, saveAudioInputDeviceId: f } = B({
    preventSave: !o
  }), s = e.useCallback(
    (v, a) => {
      a && t(v);
    },
    [t]
  );
  return /* @__PURE__ */ e.createElement("div", { ...C }, g.microphone && /* @__PURE__ */ e.createElement("div", { className: "lk-button-group" }, /* @__PURE__ */ e.createElement(
    N,
    {
      source: E.Source.Microphone,
      showIcon: !0,
      onChange: s,
      onDeviceError: (v) => i?.({ source: E.Source.Microphone, error: v })
    },
    /* @__PURE__ */ e.createElement(De, { trackRef: c, barCount: 7, options: { minHeight: 5 } })
  ), /* @__PURE__ */ e.createElement("div", { className: "lk-button-group-menu" }, /* @__PURE__ */ e.createElement(
    L,
    {
      kind: "audioinput",
      onActiveDeviceChange: (v, a) => f(a ?? "default")
    }
  ))), g.leave && /* @__PURE__ */ e.createElement(J, null, "Disconnect"), /* @__PURE__ */ e.createElement(z, null));
}
export {
  nt as AudioConference,
  Z as Chat,
  ee as ControlBar,
  L as MediaDeviceMenu,
  tt as PreJoin,
  at as VideoConference,
  ct as VoiceAssistantControlBar,
  et as usePreviewDevice,
  Ke as usePreviewTracks
};
//# sourceMappingURL=prefabs.mjs.map
